import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class DesignerMoreOptionTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__MORE_OPTION;

	get id(): string {
		return TourId.DESIGNER__MORE_OPTION;
	}

	override get keyForPersistantDone(): string {
		return DesignerMoreOptionTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: true,
				attachTo: () => {
					return $('#boardSettings .pill-option-more');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
